exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.sub-title[data-v-186087f8] {\n    color: #808891;\n}\n", ""]);

